<script lang="ts" setup>
import { useRouter } from 'vue-router'

defineOptions({ name: 'Error' })

const router = useRouter()
</script>

<template>
  <el-result icon="error" title="500" sub-title="抱歉，服务器出错了">
    <template #extra>
      <el-button type="primary" @click="router.push('/')">返回首页</el-button>
    </template>
  </el-result>
</template>
